"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _button = _interopRequireDefault(require("@ux/button"));
var _mic = _interopRequireDefault(require("@ux/icon/mic"));
var _stop = _interopRequireDefault(require("@ux/icon/stop"));
var _reactMintl = require("@godaddy/react-mintl");
var _tooltip = _interopRequireDefault(require("@ux/tooltip"));
var _utils = require("@site/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const VoiceSearchButton = ({
  disableSearch,
  voiceSearchProps,
  onSearch,
  setShowCustomSuggestions,
  isMobile,
  overlayEnabled,
  isDropDownOpen,
  buttonClassnames,
  voiceToTextEid,
  voiceToTextErrorEid,
  SpeechRecognitionApiError,
  market
}) => {
  const {
    voiceButtonText,
    voiceTooltipText,
    voiceButtonStyling
  } = voiceSearchProps;
  const [isRecording, setIsRecording] = (0, _react.useState)(false);
  const [showTooltip, setShowTooltip] = (0, _react.useState)(false);
  const anchorRef = (0, _react.useRef)(null);
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const voiceToTextTranscription = () => {
    try {
      const SpeechRecognition = window?.SpeechRecognition || window?.webkitSpeechRecognition;
      const recognition = new SpeechRecognition();
      recognition.lang = market;
      recognition.continuous = false;
      recognition.interimResults = false;
      if (isRecording) {
        setIsRecording(false);
        recognition.stop();
        return;
      }
      recognition.onresult = event => {
        setIsRecording(false);
        const voiceQuery = event.results[0][0].transcript;
        const voiceQueryData = {
          voiceQuery
        };
        onSearch(voiceQuery);
        setShowCustomSuggestions(false);
        (0, _utils.logEvent)({
          eid: voiceToTextEid,
          type: 'click',
          properties: voiceQueryData
        });
      };
      recognition.onerror = () => {
        setIsRecording(false);
        (0, _utils.logEvent)({
          eid: voiceToTextErrorEid,
          type: 'click'
        });
      };
      recognition.start();
      setIsRecording(true);
    } catch (error) {
      setIsRecording(false);
      (0, _utils.logEvent)({
        eid: SpeechRecognitionApiError,
        type: 'click',
        properties: {
          error: JSON.stringify(error)
        }
      });
    }
  };
  const buttonText = !isMobile && voiceButtonText && /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: voiceButtonText
  });
  const design = voiceButtonStyling?.buttonDesign || 'secondary';
  const icon = isRecording ? /*#__PURE__*/_react.default.createElement(_stop.default, {
    "data-cy": "stop-icon",
    fill: "#FF0000"
  }) : /*#__PURE__*/_react.default.createElement(_mic.default, {
    "data-cy": "mic-icon",
    fill: voiceButtonStyling?.buttonIconColor || 'currentColor'
  });
  const tooltipEnabled = showTooltip && voiceTooltipText && !isMobile;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_button.default, {
    id: "voice-to-text-button",
    "data-testid": "voice-to-text-button",
    design: design,
    icon: icon,
    onClick: voiceToTextTranscription,
    onMouseEnter: () => setShowTooltip(true),
    onMouseLeave: () => setShowTooltip(false),
    onFocus: () => setShowTooltip(true),
    onBlur: () => setShowTooltip(false),
    type: "button",
    "aria-label": formatMessage({
      id: 'voiceSearch.ai'
    }),
    ref: anchorRef,
    size: "sm",
    text: buttonText,
    disabled: disableSearch,
    className: (0, _classnames.default)(buttonClassnames, {
      'search-max-zindex': overlayEnabled && isDropDownOpen,
      'pr-1 pl-1': isMobile,
      'voice-button-color-customized': voiceButtonStyling?.buttonColor,
      'voice-button-border-customized': voiceButtonStyling?.buttonBorder
    })
  }), tooltipEnabled && /*#__PURE__*/_react.default.createElement(_tooltip.default, {
    className: "voice-search-tooltip",
    placement: 'bottom',
    anchorRef: anchorRef,
    role: 'tooltip'
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      maxWidth: '20rem',
      width: 'max-content'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: voiceTooltipText || 'voiceSearch.ai.tooltip'
  }))));
};
VoiceSearchButton.propTypes = {
  buttonClassnames: _propTypes.default.string,
  isMobile: _propTypes.default.bool,
  onSearch: _propTypes.default.func,
  setShowCustomSuggestions: _propTypes.default.func,
  market: _propTypes.default.string,
  voiceToTextEid: _propTypes.default.string,
  voiceToTextErrorEid: _propTypes.default.string,
  SpeechRecognitionApiError: _propTypes.default.string,
  disableSearch: _propTypes.default.bool,
  voiceSearchProps: _propTypes.default.shape({
    useVoiceSearch: _propTypes.default.bool,
    voiceButtonText: _propTypes.default.string,
    voiceTooltipText: _propTypes.default.string,
    voiceButtonStyling: _propTypes.default.shape({
      buttonDesign: _propTypes.default.string,
      buttonColor: _propTypes.default.string,
      buttonIconColor: _propTypes.default.string,
      buttonBorder: _propTypes.default.string
    })
  })
};
var _default = exports.default = VoiceSearchButton;